module.exports = __webpack_public_path__ + "static/media/s_icon_01.83375e9c.png";